const galleryRo = {
    "file_upload_successful": "Încărcarea fișierului a reușit",
    "file_upload_error": "Eroare la încărcarea fișierului",
    "attach_files": "Atașați fișiere",
    "files_selected": "fișiere selectate",
    "upload": "Încărcare",
    "uploading": "Încărcare",
    "maximum_file_size": "Dimensiunea maximă permisă pentru încărcare este de 10 MB.",
    "download": "Descărcare",
    "open_in_new_tab": "Deschide într-o filă nouă",
    "delete_file": "Ștergeți fișierul",
    "confirm_delete": "Sigur vrei să ștergi acest fișier?",
    "image_in_use": "Imaginea selectată este utilizată în următoarele elemente de meniu active:",
    "image_in_use_tip": "Pentru a șterge acest fișier, vă rugăm să îl eliminați din toate anunțurile active.",
    "file_deleted_successfully": "Fișierul a fost șters cu succes",
    "error_deleting_file": "Eroare la ștergerea fișierului",
    "confirm_selection": "Confirmați selecția",
    "file_deletion_forbidden": "Ștergerea fișierelor este interzisă"
};

export default galleryRo;
